import React from 'react';

import { Heading, Pane } from 'evergreen-ui';
import LogoImage from '../../../resources/logo.png';

import PackageJSON from '../../../../package.json';

export default function Logo() {
    return (<Pane display="flex" alignItems="center">
        <Pane marginRight={10}>
            <img src={LogoImage} style={{maxHeight: 40}} height={40} alt="App Logo"/>
        </Pane>
        <Heading size={500} className="orchestra-logo-text">
            KRIT Orchestrator v{PackageJSON.version} - {process.env.REACT_APP_MERCHANT}
        </Heading>
    </Pane>)
}
